import { Box, Text, Link, Icon } from '@nimbus-ds/components';
import { ArrowsHorizontalIcon, CameraIcon } from '@nimbus-ds/icons';
import { Thumbnail } from '@tiendanube/components';
import { useResponsive } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { HiddenProductPill } from 'domains/Catalog/Products/pages/ProductListPage/components';
import { LinkGoToProduct } from 'domains/Catalog/Products/pages/ProductListPage/components/ProductResultsDesktop/components/ResultRowDesktop/components';
import { TransferProduct } from 'domains/Catalog/Transfers/utils';

interface TransferProductCellProps {
  product: TransferProduct;
  onTransferTotalStock?: (productId: string) => void;
}

function TransferProductCell({
  product,
  onTransferTotalStock,
}: Readonly<TransferProductCellProps>) {
  const t = useTranslationCatalog();

  const { isDesktop } = useResponsive();

  return (
    <Box display="flex" flexDirection="row" gap="2" flexShrink="0">
      <Box flexShrink="0">
        {product.imageUrl ? (
          <Thumbnail
            src={product.imageUrl}
            altText={product.name}
            width="70px"
            aspectRatio="1-1"
          />
        ) : (
          <Thumbnail.Empty
            aspectRatio="1-1"
            width="70px"
            placeholderIcon={CameraIcon}
          />
        )}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        gap="0-5"
      >
        {isDesktop ? (
          <LinkGoToProduct
            title={product.name}
            id={product.productId}
            bold
            target={onTransferTotalStock ? '_blank' : undefined}
          />
        ) : (
          <Text fontSize="highlight" color="neutral-textHigh">
            {product.name}
          </Text>
        )}
        {onTransferTotalStock && (
          <Link
            as="button"
            appearance="primary"
            onClick={() => onTransferTotalStock(product.productId)}
            textDecoration="none"
          >
            <Icon
              source={<ArrowsHorizontalIcon />}
              color="primary-interactive"
            />
            <Text fontSize="caption" color="primary-interactive">
              {t('transfers.new.table.transferTotalStock')}
            </Text>
          </Link>
        )}
        {!product.visible && (
          <HiddenProductPill id={`${product.productId}`} withIcon />
        )}
      </Box>
    </Box>
  );
}

export default TransferProductCell;
